import React from 'react';
import { Box } from '@mui/material';

const ENCYDATA_LOGO_URL = 'https://encycdata.com/static/media/logo.f8886f3d8aa8acd1ba80.png';

interface EncycdataLogoProps {
  height?: number;
  /** Use light background so logo is visible on dark (e.g. purple) toolbars */
  lightBackground?: boolean;
  sx?: object;
}

/** Encycdata brand logo for portal header. Use lightBackground on dark toolbars. */
const EncycdataLogo: React.FC<EncycdataLogoProps> = ({ height = 32, lightBackground = false, sx = {} }) => (
  <Box
    component="a"
    href="https://encycdata.com"
    target="_blank"
    rel="noopener noreferrer"
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      textDecoration: 'none',
      flexShrink: 0,
      ...(lightBackground && {
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        padding: '4px 8px',
        borderRadius: 1,
        boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
      }),
      ...sx,
    }}
    aria-label="Encycdata"
  >
    <Box
      component="img"
      src={ENCYDATA_LOGO_URL}
      alt="Encycdata"
      sx={{
        height: `${height}px`,
        width: 'auto',
        maxHeight: '100%',
        objectFit: 'contain',
      }}
    />
  </Box>
);

export default EncycdataLogo;
export { ENCYDATA_LOGO_URL };
